import { FieldPattern } from '..';

import { MULTIPLE_SELECT } from '../../../../constants/FieldTypeConstants';
import {
  DropdownOptionsType,
  FormFieldsType
} from '../../../../types/FieldModelTypes';
import { prepareOptions } from '../../../../utils/FieldUtils';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class MultipleSelectFieldModel extends FormFieldWithInitialValue {
  readonly type: string = MULTIPLE_SELECT;
  options: Array<DropdownOptionsType>;
  initialSelectFieldNumber: number;
  minimumSelectFieldAllowed: number;
  addSelectFieldText: string;
  dependentOnFields: Array<string>;
  constructor(multipleSelectData: FormFieldsType, initialValue = '') {
    super(multipleSelectData, initialValue);
    this.options =
      multipleSelectData.options &&
      (multipleSelectData.options?.length > 0 ||
        Object.keys(multipleSelectData.options).length > 0)
        ? multipleSelectData.options.map((option) => prepareOptions(option))
        : [];
    this.minimumSelectFieldAllowed =
      multipleSelectData.minimum_select_field_allowed || 1;
    this.initialSelectFieldNumber =
      multipleSelectData.initial_select_field_number || 1;
    this.addSelectFieldText =
      multipleSelectData.add_select_field_text || '+ Add More...';
    this.isExpectedRemoval = true;
    this.dependentOnFields = multipleSelectData.dependent_on_fields || [];
  }
  match<T>(p: FieldPattern<T>): T {
    return p.MultipleSelectField(this);
  }
}
export default MultipleSelectFieldModel;
